import React, { useEffect, useRef } from 'react';

const LoadingSound = ({ isComplete }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    // Создаем аудио контекст для генерации звуков
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioContext = new AudioContext();

    // Функция для создания звукового сигнала
    const createBeep = (frequency, duration, type = 'sine') => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
      oscillator.type = type;
      
      gainNode.gain.setValueAtTime(0, audioContext.currentTime);
      gainNode.gain.linearRampToValueAtTime(0.1, audioContext.currentTime + 0.01);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + duration);
    };

    // Звук при завершении загрузки
    if (isComplete) {
      // Создаем мелодию завершения
      setTimeout(() => createBeep(523.25, 0.2), 0); // C5
      setTimeout(() => createBeep(659.25, 0.2), 200); // E5
      setTimeout(() => createBeep(783.99, 0.4), 400); // G5
    }

    return () => {
      if (audioContext.state !== 'closed') {
        audioContext.close();
      }
    };
  }, [isComplete]);

  return null; // Этот компонент не рендерит ничего визуально
};

export default LoadingSound; 